/**
 * Data type for attributes
 *
 * FIXME Not all of these are supported by every control
 */
export var AttributeDataType;
(function (AttributeDataType) {
    /**
     * String
     *
     * @example "Hello World!"
     */
    AttributeDataType["String"] = "String";
    /**
     * Integer
     *
     * @todo BigInt?
     * @example 1234
     */
    AttributeDataType["Integer"] = "Integer";
    /**
     * Double precision Floating point number
     * - currently not supported in edit
     * @example 12.34
     */
    AttributeDataType["Double"] = "Double";
    /**
     * Boolean
     * - currently not supported in edit
     * @example true
     *
     */
    AttributeDataType["Bool"] = "Bool";
    /**
     * Boolean (compatibility) ⚠️
     * - currently not supported in edit
     * Conflict data manager / product configurator
     * @example true
     * @deprecated Use {@link AttributeDataType.Bool} instead
     */
    AttributeDataType["Boolean"] = "Boolean";
    /**
     * Configuration object
     * - not supported in edit
     */
    AttributeDataType["Object"] = "Object";
})(AttributeDataType || (AttributeDataType = {}));
//# sourceMappingURL=AttributeDataType.js.map